// extracted by mini-css-extract-plugin
export default {"chat-not-init":"PIyK7ulJLdKou0A","loader":"jXJVbKClT0cljLk"};